var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 5L20.2809 9.72609C20.4227 9.9034 20.5 10.1237 20.5 10.3508V17C20.5 18.1046 19.6046 19 18.5 19H6.5C5.39543 19 4.5 18.1046 4.5 17V10V7C4.5 5.89543 5.39543 5 6.5 5H8.5",
    stroke: "#388AF7",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 4L12.5 15M9.5 11.7273L12.4293 14.9229C12.4683 14.9655 12.5317 14.9655 12.5707 14.9229L15.5 11.7273",
    stroke: "#388AF7",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/Save.72e50268bd46c9aab50ecd4aef58afb3.svg";
export { ForwardRef as ReactComponent };